import { Card, CardHeader, Typography } from "@/components/ui";
import { serverErrorFallbackText } from "@/lib/data/static/fallbackMessages";

interface ServerErrorFallbackCardProps {
  message?: string;
}

export function ServerErrorFallbackCard({
  message,
}: ServerErrorFallbackCardProps) {
  return (
    <Card className="h-[300px] justify-center">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <Typography variant="subHeading">
          {message ?? serverErrorFallbackText}
        </Typography>
      </CardHeader>
    </Card>
  );
}
